import React from 'react';
export function StarIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.562 21.56a.99.99 0 01-.464-.116L12 18.765l-5.1 2.68a1 1 0 01-1.45-1.055l.974-5.675L2.3 10.7A1 1 0 012.854 9l5.7-.828L11.1 3a1.04 1.04 0 011.8 0l2.549 5.164 5.7.828A1 1 0 0121.7 10.7l-4.124 4.02.974 5.675a1 1 0 01-.986 1.17l-.002-.006zM12 16.635c.162 0 .322.04.465.115l3.769 1.98-.719-4.2a1 1 0 01.287-.885l3.049-2.972-4.213-.613a1 1 0 01-.753-.547L12 5.7l-1.885 3.818a1 1 0 01-.753.547l-4.213.613L8.2 13.65a1 1 0 01.287.885l-.719 4.2 3.769-1.98a.995.995 0 01.463-.119z"
  }));
}